export function calculateAxxelistFees(rent: number, percent: number): number {
    return Number((rent * percent).toFixed(2));
}

export function calculateMoveInPrice(rent: number, deposit: number, axxelistFees: number): number {
    return Number((2 * rent + deposit + axxelistFees).toFixed(2));
}